 
import { Avatar, Box, Button } from "@mui/material";
import React from "react";
import { PageLoader } from "../../../../../../components/PageLoader/PageLoader";
import {
  IDataTableProps,
  MobileLogoRenderType,
  RenderType,
} from "../../../../../../components/Table/interfaces/IDataTableProps";
import { DataTable } from "../../../../../../components/Table/DataTable";
import { useNavigate, useOutletContext } from "react-router-dom";
import { StandardTableActions } from "../../../../../../components/StandardTableActions/StandardTableActions";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../hooks";
import { LoadState } from "../../../../../../constants/enums";
import { showMessage } from "../../../../../../redux/messages/messagesActions";
import { downLoadFile } from "../../../../../../features/FileUpload/utils";
import { StatusRenderer } from "../../../../../../components/ActiveInActiveStatus/ActiveInActiveStatus";
import { fetchCommAutoPolicyBinderistListAsync } from "../../../../../../redux/commAutoPolicy/commAutoMarketingHistory/commAutoMarketingHistoryActions";
import { BinderDialog } from "./BinderDialog";
import { BinderPreview } from "./BinderPreview";
import { ICommAutoBinder } from "../../../../../../redux/commAutoPolicy/commAutoMarketingHistory/commAutoMarketingHistory.types";

interface ICommAutoBinderListProps {
  checklistSaved: boolean;
}

export const CommAutoBinderList: React.FC<ICommAutoBinderListProps> = ({ checklistSaved }) => {
  const data = useOutletContext() as any;
  const customerId = data[0];
  const customerpolicyId = data[1];
  const navigate = useNavigate();
  const [openBinder, setOpenBinder] = React.useState(false);

  const { list, loading } = useSelector(
    (storeState: IStoreState) =>
      storeState.commAuto.marketing.binderHistory
  );
  const dispatch = useDispatchWrapper();
  const [openPreview, setOpenPreview] = React.useState<number | null>(null);
  const [downloadingLoading, setDownloading] = React.useState(false);

  const handlePreviewOpen = (customerPolicyId: number) => () => {
    setOpenPreview(customerPolicyId);
  };

  const handleDownload = (row: ICommAutoBinder) => async () => {
    try {
      setDownloading(true);
      for (const item of row.attachment) {
        await downLoadFile(item);
      }
    } catch (err: any) {
      dispatch(
        showMessage({
          displayAs: "snackbar",
          message: err.response.data.message,
          type: "error",
        })
      );
    } finally {
      setDownloading(false);
    }
  };

  const marketingActivityTableProps: IDataTableProps = {
    isPagination: false,
    isDataLoading: loading === LoadState.InProgress,
    tableCommandBarProps: {
      leftItems: {},
      rightItems: {
        customPlugins: [
          {
            key: "status",
            onRender: () => (
              <Box>
                <Button
                  sx={{ mx: 1 }}
                  variant="contained"
                  onClick={() => setOpenBinder(true)}
                  disabled={!checklistSaved}
                >
                  Generate Binder
                </Button>
              </Box>
            ),
          },
        ],
      },
    },
    mobileLogo: {
      type: MobileLogoRenderType.reactNode,
      onMobileLogoRender: (data: any) => {
        return (
          <Avatar
            sx={{
              width: 45,
              height: 45,
              color: "#fff",
              ml: "-8px",
              mr: 2,
            }}
          ></Avatar>
        );
      },
    },
    columns: [
      {
        key: "customer_policy_id",
        headerName: "Customer Policy ID",
        fieldName: "customer_policy_id",
        renderType: RenderType.TEXT_DARK,
        exportCellWidth: 15,
        enableSorting: true,
      },
      {
        key: "created_by_id",
        headerName: "Created By",
        fieldName: "created_by_id",
        renderType: RenderType.CHIP_WARNING,
        exportCellWidth: 30,
        enableSorting: true,
      },

      {
        key: "status",
        headerName: "Staus",
        fieldName: "status",
        renderType: RenderType.CUSTOM_RENDER,
        exportCellWidth: 30,
        enableSorting: true,
        onRowCellRender: (value, row) => {
          return <StatusRenderer status={row.status} />;
        },
      },

      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        renderType: RenderType.CUSTOM_RENDER,
        headingAlign: "center",
        onRowCellRender: (value, row: ICommAutoBinder) => {
          return (
            <StandardTableActions
            downloadLoading={downloadingLoading}
              onDownLoadClick={handleDownload(row)}
              onDownloadPreview={handlePreviewOpen(row.customer_policy_id)}
              // more={{ menuItems: menuItems }}
            />
          );
        },
      },
    ],
    items: list,
  };

const fetchList = () => {
  // React.useEffect(() => {
    dispatch(fetchCommAutoPolicyBinderistListAsync(customerpolicyId));
  // }, [customerpolicyId]);
}

React.useEffect(() =>{
  fetchList();
}, [customerpolicyId])

const handleComplete = () => {
  fetchList();
  setOpenBinder(false);
}

  return (
    <>
      <PageLoader loading={false}>
        <Box sx={{ mt: 2 }}>
          <DataTable {...marketingActivityTableProps} />
        </Box>
      </PageLoader>
      {openBinder && (
        <BinderDialog
          open={openBinder}
          customerPolicyId={customerpolicyId}
          onClose={() => setOpenBinder(false)}
          onComplete={handleComplete}
        />
      )}
      {openPreview && (
        <BinderPreview
          customerPolicyId={openPreview}
          open={true}
          onClose={() => setOpenPreview(null)}
          onComplete={() => {}}
        />
      )}
    </>
  );
};
